import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../../navbar/Navbar";
import Footer from "../../footer/Footer";
import SmoothScroll from "../../public/SmoothScroll";
import { useFontsRefresh } from "../../public/Journal";

// Shell for info and docs pages: same masthead and footer as the landing page.
function StandalonePageLayout({ children }) {
    const [isOpen, setIsOpen] = useState(false);
    const location = useLocation();
    useFontsRefresh();

    useEffect(() => {
        setIsOpen(false);
        window.scrollTo(0, 0);
    }, [location.pathname]);

    return (
        <div className="public-site relative min-h-screen flex flex-col">
            <SmoothScroll />

            <header className="relative z-30 w-full print:hidden">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-2">
                    <Navbar isOpen={isOpen} setIsOpen={setIsOpen} />
                </div>
            </header>

            <main className="relative z-10 flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    {children}
                </div>
            </main>

            <div className="relative z-10 print:hidden">
                <Footer />
            </div>
        </div>
    );
}

export default StandalonePageLayout;
